import React from 'react';

const InfoSaubenoise = () => {
  return (
    <div className="flex flex-col items-center p-4">
      <img
        src='/picture/flyer_saubenoise.png'
        alt="Flyer de la Saubenoise"
        className="max-w-full h-auto rounded shadow"
      />
    </div>
  );
};

export default InfoSaubenoise;
